import { type TPlan as TApiPlan } from '@core/api'

import { type TPlan } from '@core/models'

import { convertLimits } from './convertLimits'
import { convertSubscription } from './convertSubscription'
import { convertUsage } from './convertUsage'

export const convertPlan = (apiPlan: TApiPlan): TPlan => {
    return {
        id: apiPlan.id,
        type: apiPlan.plan,
        name: apiPlan.name,
        userId: apiPlan.user_id,
        dateExpire: apiPlan.date_expire,
        subscription: convertSubscription(apiPlan.subscription),
        limits: convertLimits(apiPlan.limits),
        usage: convertUsage(apiPlan.usage),
        hasSubscription: apiPlan.has_subscription,
    }
}
